// extracted by mini-css-extract-plugin
export default {"descriptions":"descriptions___jlSMv","addFieldsButton":"addFieldsButton___OIkWo","fullWidth":"fullWidth___fh_av"};